/** @format */

import { HeaderStoreSelection, NearbyStores } from '@shared/data-access/interfaces';
import { createAction, props } from '@ngrx/store';

export const setUserStoreName = createAction(
	'[On Load] Set User Store Name',
	props<{ storeName: string }>()
);

export const setUserStoreInfoFromCookie = createAction(
	'[On Load] Set User Store Zip Code',
	props<{ location: string; name: string; zipcode: string }>()
);

export const setUserZipCode = createAction(
	'[On Load] Set User Zip Code',
	props<{ zipCode: string }>()
);

export const setHeaderServiceStoreInfo = createAction(
	'[On Load] Set Header Service Store Information',
	props<{ storeInfo: HeaderStoreSelection }>()
);

// Added to being able to distinguish loading the store info from the header vs updating it
// important to avoid product list updating twice on load
export const changeHeaderServiceStoreInfo = createAction(
	'[On Change] Change Header Service Store Information',
	props<{ storeInfo: HeaderStoreSelection }>()
);

export const setNearbyStores = createAction(
	'[On Store Set] Set Nearby Stores',
	props<{ nearbyStores: NearbyStores }>()
);
